import React from 'react'
import './style.css'
import Header from '../../Components/Header/Header'
import Footer from '../../Components/Footer/Footer'

const TempleInnImages=[

"https://r2imghtlak.mmtcdn.com/r2-mmt-htl-image/htl-imgs/200709112020224153-a231695b-b29b-45c2-98a4-364eb889dee7.jpg?downsize=540:*",

"/Images/daanorcid.jpeg",
"https://dynamic-media-cdn.tripadvisor.com/media/photo-o/2b/f2/8d/37/caption.jpg?w=1000&h=-1&s=1",

"https://dynamic-media-cdn.tripadvisor.com/media/photo-o/2b/f2/8d/2f/caption.jpg?w=1000&h=-1&s=1",
"https://s3.ap-south-1.amazonaws.com/buzz.beconf.test/daan-orchid-residency/super-deluxe-Premium%2014.jpg",
"https://s3.ap-south-1.amazonaws.com/buzz.beconf.test/daan-orchid-residency/premium-rooms-Premium%201.jpg",
"https://s3.ap-south-1.amazonaws.com/buzz.beconf.test/daan-orchid-residency/royal-suite-Suite%201.jpg",

"https://r2imghtlak.mmtcdn.com/r2-mmt-htl-image/htl-imgs/200709112020224153-3beeb253-73fb-4ee6-89a2-2d74491adc85.jpg?downsize=540:*",
"/Images/daanorch2.jpeg",
"/Images/danorchmar.jpeg"
// "https://lh3.googleusercontent.com/gps-cs-s/AHRPTWmCFc1phVqiHSj8iqGDkVOcMvW0Jzu35EtyemRrE-P_eSkgBiN01zwSTklj--eN55Wm_nRkTKwQWkx6m1PKIdYk_0qX73HqSV48qD-TSQEOXOLAZtKt8ry2LUszV9kiz99DJMqzsg=s680-w680-h510-rw"

]

const DaanOrchid = () => {
  return (
    <div className='daan-lux-inn'>
      <Header number={"+91 094460 71141"} booklink={'https://bookings.daanhotels.com/book/daan-orchid-residency'}></Header>
      <section className='section-1'> <h1>Daan Orchid Residency</h1> <h3>Luxury Business Hotel</h3> 
        <p>Pulimoodu Rd, Pulimoodu Junction, Kottayam, Kerala 686001<br /> <span style={{padding:"10px",textDecoration:"underline"}}>Mob: 094460 71141</span> </p>

       <button onClick={()=>window.open('https://bookings.daanhotels.com/book/daan-orchid-residency')} className='lux-inn-btn'>Book Now</button> <div className="sec-1-images">
        <img src={TempleInnImages[0]} alt="" />
        <img src={TempleInnImages[1]} alt="" />
        <img src={TempleInnImages[2]} alt="" />
        </div> </section>
      <section className='section-2'> 
        <div className="sec-2-card">
           <h2>Experience Luxury and Elegance at Orchid Residency</h2>  <br />

           <p>Welcome to Orchid Residency, where refined comfort meets exceptional hospitality in the heart of Kottayam.
             Our elegantly designed rooms and premium amenities offer the perfect blend of style, relaxation, and convenience. From plush bedding and
             sophisticated interiors to modern facilities, high-speed Wi-Fi, and personalized service, every detail is crafted to elevate your stay.
             <br /> <br />Welcome to Orchid Residency, where refined comfort meets exceptional hospitality in the heart of Kottayam. 
            </p>  
        </div>  
         <img className='img-shade' src={TempleInnImages[3]} alt="" />
          </section>
   <section className='section-3'>
    <h1>40 Room & Suits</h1> <button style={{width: '120px', margin:'auto'}} onClick={()=>window.open('https://bookings.daanhotels.com/book/daan-orchid-residency')} className='lux-inn-btn'>Book Now</button> 
    <div className="sec-3-cards">
      <div className="sec-3-card-1">
        <img src={TempleInnImages[4]} alt="" />
        {/* <p>MAX 3 GUESTS / 1 QUEEN OR 2 SINGLE BEDS</p> */}
          <dash></dash>
        <p>Super Deluxe</p>
      </div>
         <div className="sec-3-card-1">
        <img src={TempleInnImages[5]} alt="" />
            {/* <p>MAX 3 GUESTS / 1 QUEEN OR 2 SINGLE BEDS</p> */}
      <dash></dash>
        <p>Premium Rooms</p>
      </div>   <div className="sec-3-card-1">
        <img src={TempleInnImages[6]} alt="" />
            {/* <p>MAX 3 GUESTS / 1 QUEEN OR 2 SINGLE BEDS</p> */}
         <dash></dash>
        <p>Royal Suite</p>
      </div>
    </div>
   </section>

       <section className='section-4'> 
          <div className="sec-4-card">

        <h1>Modern Bathrooms Designed for Comfort</h1> <br />
         <p>Experience the perfect blend of comfort and functionality in our thoughtfully
 designed bathrooms. Featuring premium fixtures, elegant finishes, spacious layouts, and
  complimentary luxury toiletries, each bathroom offers a clean, refreshing space to start and end your day. 
  Enjoy a relaxing shower, soft towels, and modern amenities that enhance your stay with convenience and style.
</p> 
          </div>

      <div className="sec-4-card-2">
       <img style={{maxHeight:"450px", objectFit:"cover"}} className='img-shade' src={TempleInnImages[7]} alt="" />
       <p className='img-p'>Experience elegant interiors, modern amenities, and spotless comfort.</p>
      </div>
       </section>

<section className='section-5' >
  <div className="sec-5-card">
     <button onClick={()=>window.open('https://bookings.daanhotels.com/book/daan-orchid-residency')} className='lux-inn-btn'>Book Now</button> 
  <h2 className='sec-5-bold'>Elegant Banquet Hall for Memorable Celebrations</h2>
<img src={TempleInnImages[8]} alt="" />
<p className='img-p' >
 Celebrate life's special moments in our spacious and elegantly designed banquet hall. Perfect for weddings, receptions, engagements, 
 
 and exceptional hospitality to make every event truly unforgettable..</p>
  </div>
 <img className='sec-5-img img-shade' src={TempleInnImages[9]} alt="" />
</section>
<div className="thekkady-map">

<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3934.0717000922364!2d76.5210836!3d9.589088199999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b062ba0c213d92d%3A0x604a1e1cabeca535!2sDaan%20Orchid%20Residency!5e0!3m2!1sen!2sin!4v1785818538154!5m2!1sen!2sin"
 width="40%"
 height="450px"
 allowfullscreen=""  
  loading="lazy" 
  referrerpolicy="no-referrer-when-downgrade"
      >
        
      </iframe>


   <p><strong>Address:</strong>Pulimoodu Rd, Pulimoodu Junction, Kottayam, Kerala 686001<br />
      <span style={{ textDecoration:"underline",
        padding:"0px"}}>Mob : 094460 71141</span> </p>
  </div>

   <Footer num={0-9446071141}/>


    </div>
  )
}

export default DaanOrchid